import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import TextRenderer from './../TextRenderer'

import styles from './styles.module.scss'

const Facts = (props) => {
	return (
		<SbEditable content={props.blok}>
			<section className={styles['facts']}>
                {props.blok.vertical_title && <span className='section-title section-title--facts'>{props.blok.title}</span>}
                <ul className={styles['facts__list']}>
                    {props.blok.fact_items.map(blok => {
                        
                        const iconClasses = cx({
                            [styles['fact-item__icon']]: true,                            
                            [styles['fact-item__icon--padding']]: blok.image.filename && blok.title,
                        })

                        return (
                            <SbEditable content={blok} key={blok._uid}>
                                <li className={styles['fact-item']} style={{ backgroundColor: blok.background_color }}>
                                    <div className={styles['fact-item__inner']}>
                                        {blok.image.filename && (
                                            <img className={iconClasses} src={blok.image.filename} alt={blok.image.alt} />
                                        )}
                                        {blok.title != '' && <TextRenderer className={styles['fact-item__title']} text={blok.title} />}
                                        {blok.content != '' && <TextRenderer className={styles['fact-item__description']} text={blok.content}/>}
                                    </div>
                                </li>
                            </SbEditable>
                        )
                    })}
                </ul>
            </section>
		</SbEditable>
	)
}

export default Facts
